<template>
<v-container>
  <v-overlay :value="loading">
    <v-progress-circular
        indeterminate
        size="64"
    ></v-progress-circular>
  </v-overlay>
  <v-row>
    <v-col cols="12">
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" lg="6" md="6" sm="12">
                          <v-autocomplete
                              v-model="wybrany_klient"
                              :loading="isLoadingClients"
                              :items="clientsList"
                              :search-input.sync="clientKeyword"
                              cache-items
                              flat
                              no-data-text="Nieznaleziono"
                              hide-details
                              return-object
                              item-text="full_text"
                              item-value="id"
                              label="Wyszukaj pacjenta Imię/Nazwisko/PESEL"
                          >
                            <template slot="append-outer">
                              <v-btn fab small color="primary">
                                <v-icon  title="Szybkie dodanie pacjenta" @click="quickAddClient"
                                         v-if="$can('do','POKO_Klienci_Edycja')">fa-plus</v-icon>
                              </v-btn>
                              <v-btn fab small color="success" class="ml-2" @click="addToListSelected">
                                <v-icon  title="Dodaj do listy">fa-arrow-down</v-icon>
                              </v-btn>
                            </template>
                            <template v-slot:selection="data">
                              <v-container fluid>
                                <v-row no-gutters>
                                  <v-col>
                                    {{data.item.name + ' '+data.item.surname}}
                                  </v-col>
                                  <v-col>
                                    {{ data.item.description != null ? data.item.description.substr(0,19) : ''}}
                                  </v-col>
                                  <v-col>
                                    {{data.item.pesel}}
                                  </v-col>
                                  <v-col class="text-right">
                                    <v-icon class="mr-2">fa-phone</v-icon>{{data.item.phone}}
                                  </v-col>
                                </v-row>
                              </v-container>
                            </template>
                            <template v-slot:item="data">
                              <v-container fluid>
                                <v-row no-gutters>
                                  <v-col>
                                    {{data.item.name + ' '+data.item.surname}}
                                  </v-col>
                                  <v-col>
                                    {{ data.item.description != null ? data.item.description.substr(0,19) : ''}}
                                  </v-col>
                                  <v-col>
                                    {{data.item.pesel}}
                                  </v-col>
                                  <v-col class="text-right">
                                    <v-icon class="mr-2">fa-phone</v-icon>{{data.item.phone}}
                                  </v-col>
                                </v-row>
                              </v-container>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="12">
                          <v-autocomplete v-model="wybrany_voucher" clearable :filter="customFilter" :loading="loading" :items="listaVoucherow" flat hide-details return-object item-text="nazwa" label="Wyszukaj voucher Nazwa"></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                              <tr>
                                <th class="text-left">
                                  Klient
                                </th>
                                <th class="text-left">
                                  Akcje
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr
                                  v-for="item in dodani_klienci"
                                  :key="item.id"
                              >
                                <td>{{ item.name }}</td>
                                <td><v-icon @click="deleteKlient(item.id)">fa-trash</v-icon></td>
                              </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" lg="6" md="6">
                          <v-text-field label="Numer" v-model="numer" placeholder="Pusty - system wygeneruje numer wewnętrzny"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="wybrany_voucher">
              <v-col cols="12">
                <v-card>
                  <v-card-title>Podsumowanie</v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th class="text-left">
                            Nazwa vouchera
                          </th>
                          <th class="text-left">
                            Typ vouchera
                          </th>
                          <th class="text-left">
                            Wartość
                          </th>
                          <th class="text-left">
                            Ważność
                          </th>
                          <th>
                            Cena
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>{{ wybrany_voucher.nazwa }}</td>
                          <td>{{getTypOpis(wybrany_voucher)}}</td>
                          <td>{{getWartosc(wybrany_voucher)}}</td>
                          <td>{{wybrany_voucher.waznosc_miesiace == 0 ? 'Bezterminowy' : wybrany_voucher.waznosc_miesiace + ' miesiecy'}}</td>
                          <td>{{wybrany_voucher.kwota}} zł</td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="platnosci.length > 0">
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th class="text-left">
                            Wartość
                          </th>
                          <th class="text-left">
                            Sposób
                          </th>
                          <th class="text-left">
                            Data sprzedaży
                          </th>
                          <th>
                            Akcje
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in platnosci"
                            :key="item.id"
                        >
                          <td>{{ item.payAmount }}</td>
                          <td>{{ getPaymentType(item.type) }}</td>
                          <td>{{ item.data }}</td>
                          <td><v-icon @click="deletePayment(item)">fa-trash</v-icon></td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="wybrany_voucher">
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <v-container fluid>
                      <v-row>
                        <v-col cols="12" lg="6" md="6" sm="12" align-self="end">
                          <v-text-field label="Opłata" name="payAmount"
                                        id="payAmount"
                                        v-model.number="payAmount"
                                        step="0.01"  type="number">
                            >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="12">
                          <v-container fluid>
                            <v-row>
                              <v-col cols="6" lg="3" md="3" sm="6" align-self="end">
                                <v-radio-group v-model="paymentType">
                                  <v-radio :value="0"
                                           label="Gotówka"></v-radio>
                                  <v-radio :value="1"
                                           label="Karta"></v-radio>
                                  <v-radio :value="2"
                                           label="Przelew"></v-radio>
                                </v-radio-group>
                              </v-col>
                              <v-col cols="6" lg="3" md="3" sm="6" align-self="end">
                                <v-btn color="primary"
                                       @click="addPayment" v-if="enableAddPayment">
                                  Dodaj
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" class="text-right">
      <v-btn color="error" @click="resetForm">Anuluj</v-btn>
      <v-btn color="success" class="ml-2" @click="save">Zapisz</v-btn>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="addQuickClientDialog" max-width="500px" v-if="$can('do','POKO_Klienci_Edycja')">
        <v-card>
          <v-toolbar dark class="primary">
            <v-btn icon @click.native="addQuickClientDialog = false" dark>
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>Szybkie dodanie pacjenta</v-toolbar-title>
          </v-toolbar>
          <v-progress-linear :indeterminate="true" v-if="quickClientSaving"></v-progress-linear>
          <v-card-text v-show="!quickClientSaving">
            <v-form data-vv-scope="quickAddForm" @submit.prevent="saveQuickClient">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field label="Imię*" v-validate="'required'" name="qaddname" id="qaddname"
                                data-vv-as="Imię"
                                :error-messages="errors.collect('quickAddForm.qaddname')"
                                v-model="quickAddPatientData.name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Nazwisko*" v-validate="'required'" name="qaddsurname"
                                id="qaddsurname"
                                :error-messages="errors.collect('quickAddForm.qaddsurname')"
                                data-vv-as="Nazwisko"
                                v-model="quickAddPatientData.surname"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Telefon" v-validate="{regex:/^[0-9\+]{8,13}$/}" name="qaddphone"
                                id="qaddphone"
                                :error-messages="errors.collect('quickAddForm.qaddphone')"
                                data-vv-as="Telefon" v-model="quickAddPatientData.phone"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox label="Zgoda na sms" v-model="quickAddPatientData.zgoda_na_sms"></v-checkbox>
                </v-flex>
              </v-layout>

            </v-form>
          </v-card-text>
          <v-card-actions v-show="!quickClientSaving">
            <v-btn color="success" @click="saveQuickClient">Zapisz</v-btn>
            <v-btn color="error" @click="addQuickClientDialog=false">Anuluj</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import swal from "sweetalert";
import {clientService} from "@/services/";
import {voucheryService} from "@/services/vouchery.service";
import dayjs from "dayjs";

export default {
  name: "SprzedazVoucherow",
  data()
  {
    return {
      dodani_klienci: [],
      isLoadingClients: false,
      clientKeyword: null,
      wybrany_klient: null,
      wybrany_voucher: null,
      clientTimerId: 0,
      clientsList: [],
      platnosci: [],
      payAmount: 0,
      paymentType: 0,
      listaVoucherow: [],
      numer: null,
      loading: false,
      enableAddPayment: true,
      addQuickClientDialog: false,
      quickAddPatientData: {
        name: null,
        surname: null,
        phone: null,
        zgoda_na_sms: false,
        description: null
      },
      quickClientSaving: false,
    }
  },
  mounted() {
    this.getVoucherList()
  },
  methods: {
    quickAddClient() {
      this.quickAddPatientData.name = null;
      this.quickAddPatientData.surname = null;
      this.quickAddPatientData.phone = null;
      this.quickAddPatientData.zgoda_na_sms = false;
      this.addQuickClientDialog = true;
    },
    getTypOpis(item)
    {
      switch(item.typ)
      {
        case 0:
          return 'Wizyta';
        case 1:
          return 'Czas';
        case 2:
          return 'Kwota';
      }
      return ''
    },
    getWartosc(item)
    {
      switch(item.typ)
      {
        case 0:
          return item.ilosc_wizyt+ ' wizyt';
        case 1:
          return item.czas_minuty+ ' minut';
        case 2:
          return item.kwota_do_wykorzystania+ ' zł';
      }
      return ''
    },
    addToListSelected() {
      if(this.wybrany_klient != null)
      {
        this.dodani_klienci.push({
          id: this.wybrany_klient.id,
          name: this.wybrany_klient.name
        })
        this.wybrany_klient = null
      }
    },
    saveQuickClient() {
      this.$validator.validateAll("quickAddForm").then(valid => {
        if (valid) {
          this.quickClientSaving = true;
          clientService
              .create({
                name: this.quickAddPatientData.name,
                surname: this.quickAddPatientData.surname,
                phone: this.quickAddPatientData.phone,
                agreeForHealthServices: true,
                usePhoneForSMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                patientConfirmVisitsBySMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                patientAgreeToReceiveSMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                description: this.quickAddPatientData.description
              })
              .then(resp => {
                this.quickClientSaving = false;
                this.quickAddPatientData.name = null;
                this.quickAddPatientData.surname = null;
                this.quickAddPatientData.phone = null;
                this.quickAddPatientData.zgoda_na_sms = false
                this.addQuickClientDialog = false;
                this.quickAddPatientData.description = null
                if (resp.data != null && resp.data.result != null) {
                  var quickClient = resp.data.result;
                  let newClient = {
                    id: quickClient.id,
                    name: quickClient.name,
                    surname: quickClient.surname,
                    pesel: quickClient.pesel,
                    therapist: quickClient.therapistID,
                    full_text: quickClient.name + ' '+quickClient.surname + (quickClient.pesel != null && quickClient.pesel != '' ? ' '+quickClient.pesel : '') + (quickClient.phone != null && quickClient.phone != '' ? ' '+quickClient.phone : ''),
                    disabled:false,
                    description: quickClient.description,
                    phone: quickClient.phone
                  };
                  this.clientsList.push(newClient);
                  this.wybrany_klient = newClient
                } else {
                  this.showError(false, "Błąd zapisu pacjenta");
                }
              })
              .catch(resp => {
                this.quickClientSaving = false;
                if (
                    resp.response != null &&
                    resp.response.data != null &&
                    resp.response.data.error != null
                ) {
                  this.showError(false, resp.response.data.error.message);
                } else {
                  this.showError(false, "Błąd zapisu pacjenta");
                }
              });
        }
      });
    },
    customFilter(item,queryText,itemText)
    {
      const textOne = item.nazwa.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1
    },
    deleteKlient(id)
    {
      this.dodani_klienci = this.dodani_klienci.filter(e=> e.id !== id)
    },
    fetchClientDebaunce() {
      // cancel pending call
      clearTimeout(this.clientTimerId)
      // delay new call 500ms
      this.clientTimerId = setTimeout(() => {
        this.getClientValues()
      }, 500)
    },
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    getVoucherList() {
      this.loading = true
      voucheryService.getVoucherList().then(result=> {
        this.listaVoucherow = result.data.result
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.showError(true, "Nie można pobrać listy voucherow.");
      })
    },
    getClientValues() {
      this.isLoadingClients = true;
      clientService
          .getAll({query: this.clientKeyword, page: 1, limit: 20, sorting: "surname"})
          .then(data => {
            data.data.result.items.forEach(item => {
              if (!this.clientsList.find(x => x.id === item.id)) {
                let name = item.name + " " + item.surname;
                this.clientsList.push({
                  id: item.id,
                  name: item.name,
                  surname: item.surname,
                  pesel: item.pesel,
                  therapist: item.therapistID,
                  full_text: item.name + ' '+item.surname + (item.pesel != null && item.pesel != '' ? ' '+item.pesel : '') + (item.phone != null && item.phone != '' ? ' '+item.phone : ''),
                  disabled:false,
                  description: item.description,
                  phone: item.phone
                });
              }
            });
            this.isLoadingClients = false;
          })
          .catch(() => {
            this.isLoadingClients = false;
            this.showError( "Nie można pobrać listy klientów.");
          });
    },
    addPayment() {

      let zaplacone = 0
      this.platnosci.forEach(x=> zaplacone += x.payAMount)
      if(this.payAmount > (this.wybrany_voucher.kwota - zaplacone))
      {
        this.showError("Nie można zapłacić więcej niż wartość vouchera");
        return
      }
      let id = 0
      this.platnosci.forEach(x=> {
        if(x.id > id)
          id = x.id
      })
      id= id + 1

      let elem = this.platnosci.find(x=>x.type == this.paymentType)

      if(elem)
      {
        elem.payAmount += this.payAmount
      }
      else
      {
        this.platnosci.push({
          id: id,
          payAmount: this.payAmount,
          type: this.paymentType,
          data: dayjs().format('YYYY-MM-DD HH:mm')
        })
      }

      zaplacone+= this.payAmount

      if(zaplacone < this.wybrany_voucher.kwota)
        this.payAmount = this.wybrany_voucher.kwota - zaplacone
      else {
        this.enableAddPayment = false
        this.payAmount = 0
      }

    },
    getPaymentType(payType) {
      switch (payType) {
        case 0:
          return "Gotowką";
        case 1:
          return "Kartą";
        case 2:
          return "Przelewem";
      }
    },
    deletePayment(item)
    {
      this.platnosci = this.platnosci.filter(x=> x.id !== item.id)
      this.enableAddPayment = true
    },
    resetForm() {
      this.wybrany_klient = null
      this.wybrany_voucher = null
      this.dodani_klienci = []
      this.enableAddPayment = true
    },
    save() {
      if(this.wybrany_voucher == null)
      {
        this.showError('Nie wybrano vouchera.')
        return
      }
      if(this.dodani_klienci.length == 0)
      {
        this.showError('Nie dodano klienta.');
        return
      }

      let zaplacone = 0
      this.platnosci.forEach(x=> zaplacone += x.payAmount)
      if(zaplacone != this.wybrany_voucher.kwota)
      {
        this.showError('Kwota płatności niezgodna z ceną vouchera.')
        return
      }
      let wybrani_klienci = []
      this.dodani_klienci.forEach(x=> wybrani_klienci.push(x.id))
      voucheryService.sprzedaj({
        voucher_id: this.wybrany_voucher.id,
        klienci: wybrani_klienci,
        platnosci: this.platnosci,
        numer: this.numer
      }).then(() =>{
        swal({
          title: 'Dodano',
          text: 'Pomyślnie sprzedano voucher',
          icon: 'success',
          button: "Zamknij"
        }).then(() => {
          this.resetForm()
        }).catch(err=> {
          if(err.response != null && err.response.data != null && err.response.data.error != null)
          {
            this.showError(err.response.data.error.message)
          }
          else
          {
            this.showError('Błąd sprzedaży vouchera')
          }
        })
      })
    }
  },
  watch: {
    clientKeyword(val) {
      if (val) {
        this.fetchClientDebaunce();
      }
    },
    wybrany_voucher(val) {
      if(val == null)
      {
        this.platnosci = []
      }
      else
      {
        this.payAmount = val.kwota
      }
    }
  }
}
</script>

<style scoped>

</style>